import { useMemo } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/slices/auth.slice";
import { fetchGroupSummary } from "../../services/groupConsole.service";

/**
 * Whether the group's branches collectively include a Senior branch, a
 * Junior/Montessori branch, or both — decides which Course Board tile(s)
 * GroupConsoleMenu.js shows. A single branch is exclusively one or the
 * other (Schools.is_montessori_enabled is one boolean), so "both" here
 * means the group as a whole, not any one branch.
 *
 * Reuses the same GET /group-console/:groupId/summary call
 * useGroupBranchOptions.js already makes — react-query dedupes by key, so
 * this doesn't add a second network request.
 */
export default function useGroupProgramTypes() {
  const user = useSelector(selectUser);
  const groupId = user?.group;

  const summary = useQuery(
    ["group-console-summary", groupId],
    () => fetchGroupSummary(groupId),
    { enabled: !!groupId },
  );

  return useMemo(() => {
    const branches = summary.data?.branches || [];
    return {
      hasSenior: branches.some((b) => !b.is_montessori_enabled),
      hasJunior: branches.some((b) => b.is_montessori_enabled),
      isLoading: summary.isLoading,
    };
  }, [summary.data, summary.isLoading]);
}
